@if (config().visible) {
  <div class="row" [formGroup]="formGroup">
    @if (config().label) {
      <label [for]="config().attrName">{{ config().label }}</label>
    }
    @for (radio of config().getSelectables(); track radio.key; let i = $index) {
      <div [ngClass]="config().styleClass ? config().styleClass : ''">
        <input type="radio" class="form-check-input" [name]="config().attrName" [id]="config().attrName + i" [value]="radio.value" [checked]="radio.key === value()" [disabled]="config().disabled" />
        <label [for]="config().attrName" [ngClass]="config().labelClass ? config().labelClass : ''">{{ radio.value }}</label>
      </div>
    }
  </div>
}
